export const EventFilter = {
    UPCOMING: "EventFilter.UPCOMING",
    PAST: "EventFilter.PAST",
};
